<template>
    <div class="diagram" :id=id>
    </div>
</template>

<script>
    import NodeLinkDiagramSpec from '../vega-spec/node-link-diagram.v.json'
    import embed from 'vega-embed'
    import _ from 'lodash'

    export default {
        name: "NodeLinkDiagram",
        props: ["data", "id", "legend"],
        data() {
            return {
                spec: {}
            }
        },
        watch: {
            spec(v) {
                if (v) this.draw()
            },
            data(v) {
                this.load(v)
                this.draw()
            }
        },
        mounted: function () {
            this.spec = JSON.parse(JSON.stringify(NodeLinkDiagramSpec))
            if (!this.legend) {
                delete this.spec["legends"]
            }
            // if (this.interactive) {
            //     this.spec["marks"][1]["interactive"] = true
            // }

            this.load(this.data)
        },
        methods: {
            async draw() {
                await embed('#' + this.id, this.spec, {actions: false}).catch(err => console.error(err))
            },
            load(v) {
                if (!v && v.nodes.length === 0) return;
                this.spec["data"][0]["values"] = _.cloneDeep(v.nodes)
                this.spec["data"][1]["values"] = _.cloneDeep(v.edges)

            }
        }
    }
</script>

<style scoped>
</style>

